<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">CREA SUPERVISORE</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-12">
                <div class="m-3">
                    <label for="field_name" class="form-label label-fw">
                        Nome gestione *
                    </label>
                    <input  formControlName="name" 
                            name="name" 
                            type="text" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.name.errors}"
                            class="form-control form-fw " 
                            id="field_name" 
                            placeholder="Nome">
                        <div class="invalid-feedback" *ngIf="form.touched">
                            <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                                Nome gestione è obbligatorio
                            </span>
                        </div>
                </div>
            </div> 
        </div>
    </form>

    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3" 
                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false" 
                (click)="clickButtonSave()">Salva</button>
            <button type="button" class="btn btn-outline-warning btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>